var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { id: "mmp-navbar" } }, [
    _c("nav", { class: ["sidebar-navigation", { collapsed: _vm.collapsed }] }, [
      _c("ul", { staticClass: "nav-scroll-list" }, [
        _c("li", { staticClass: "my-3 mx-2 logo-container" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("span", { staticClass: "ml-1 label" }, [
            _vm._v("Dynamic Map Platform"),
          ]),
          _vm._v(" "),
          _vm.versionReleaseInfo
            ? _c("span", { staticClass: "ml-1 label version-label" }, [
                _vm._v(
                  "MMP - Version " + _vm._s(_vm.versionReleaseInfo.version)
                ),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c(
          "li",
          {
            class: { active: _vm.currentPage === "Dashboard" },
            attrs: { title: _vm.collapsed ? "Dashboard" : null },
            on: { click: _vm.handleDashboardNav },
          },
          [
            _c("div", { staticClass: "text_format" }, [
              _c(
                "span",
                { staticClass: "nav-icon" },
                [_c("fa", { attrs: { icon: ["fas", "home"] } })],
                1
              ),
              _vm._v(" "),
              _c("span", { staticClass: "label" }, [_vm._v("Dashboard")]),
            ]),
          ]
        ),
        _vm._v(" "),
        _vm.globalIsUserAllowed("Acquisitions")
          ? _c(
              "li",
              {
                staticClass: "has-submenu",
                class: { open: _vm.groups.acquisitions && !_vm.collapsed },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "text_format group-row",
                    attrs: { title: _vm.collapsed ? "Acquisitions" : null },
                    on: {
                      click: function ($event) {
                        return _vm.toggleGroup("acquisitions")
                      },
                    },
                  },
                  [
                    _c("span", { staticClass: "group-row-main" }, [
                      _c(
                        "span",
                        { staticClass: "nav-icon" },
                        [
                          _c("fa", {
                            attrs: { icon: ["fas", "clipboard-list"] },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("span", { staticClass: "label" }, [
                        _vm._v("Acquisitions"),
                      ]),
                    ]),
                    _vm._v(" "),
                    !_vm.collapsed
                      ? _c(
                          "span",
                          { staticClass: "nav-icon submenu-caret" },
                          [
                            _c("fa", {
                              attrs: { icon: ["fas", "angle-right"] },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]
                ),
                _vm._v(" "),
                _c("ul", { staticClass: "submenu" }, [
                  _vm.globalIsUserAllowed("DPR")
                    ? _c(
                        "li",
                        {
                          staticClass: "submenu-item",
                          on: {
                            click: function ($event) {
                              return _vm.loadProjectAction(
                                "Daily Productivity Report"
                              )
                            },
                          },
                        },
                        [_vm._m(1)]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.globalIsUserAllowed("Entry_Manager")
                    ? _c(
                        "li",
                        {
                          staticClass: "submenu-item",
                          on: {
                            click: function ($event) {
                              return _vm.showModal("entryManagerModal")
                            },
                          },
                        },
                        [_vm._m(2)]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.globalIsUserAllowed("DPR_Reports")
                    ? _c(
                        "li",
                        {
                          staticClass: "submenu-item",
                          on: {
                            click: function ($event) {
                              return _vm.showModal("reportsModal")
                            },
                          },
                        },
                        [_vm._m(3)]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.globalIsUserAllowed("DPR_Admin_Console")
                    ? _c(
                        "li",
                        {
                          staticClass: "submenu-item",
                          on: {
                            click: function ($event) {
                              return _vm.showModal("adminConsoleModal")
                            },
                          },
                        },
                        [_vm._m(4)]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.globalIsUserAllowed("GTP_Tracking")
                    ? _c(
                        "li",
                        {
                          staticClass: "submenu-item",
                          on: {
                            click: function ($event) {
                              return _vm.showModal("gtpModal")
                            },
                          },
                        },
                        [_vm._m(5)]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.globalIsUserAllowed("GTP_Report")
                    ? _c(
                        "li",
                        {
                          staticClass: "submenu-item",
                          on: {
                            click: function ($event) {
                              return _vm.showModal("gtpReportModal")
                            },
                          },
                        },
                        [_vm._m(6)]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.globalIsUserAllowed("Field_Images")
                    ? _c(
                        "li",
                        {
                          staticClass: "submenu-item",
                          on: {
                            click: function ($event) {
                              return _vm.showModal("imageCarousel")
                            },
                          },
                        },
                        [_vm._m(7)]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.globalIsUserAllowed("EOD")
                    ? _c(
                        "li",
                        {
                          staticClass: "submenu-item",
                          on: {
                            click: function ($event) {
                              return _vm.loadProjectAction(
                                "EodFieldReview",
                                true
                              )
                            },
                          },
                        },
                        [_vm._m(8)]
                      )
                    : _vm._e(),
                ]),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.globalIsUserAllowed("DRT")
          ? _c(
              "li",
              {
                class: { active: _vm.currentPage === "DRT" },
                attrs: { title: _vm.collapsed ? "Delivery Review Tool" : null },
                on: {
                  click: function ($event) {
                    return _vm.handleToolNav("DRT", "Delivery Review Tool")
                  },
                },
              },
              [
                _c("div", { staticClass: "text_format" }, [
                  _c(
                    "span",
                    { staticClass: "nav-icon" },
                    [_c("fa", { attrs: { icon: ["fas", "history"] } })],
                    1
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "label" }, [
                    _vm._v("Delivery Review Tool"),
                  ]),
                ]),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.globalIsUserAllowed("ANSI")
          ? _c(
              "li",
              {
                class: { active: _vm.currentPage === "ANSI" },
                attrs: { title: _vm.collapsed ? "ANSI" : null },
                on: {
                  click: function ($event) {
                    return _vm.handleToolNav("ANSI", "ANSI")
                  },
                },
              },
              [
                _c("div", { staticClass: "text_format" }, [
                  _c(
                    "span",
                    { staticClass: "nav-icon" },
                    [_c("fa", { attrs: { icon: ["fas", "route"] } })],
                    1
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "label" }, [_vm._v("ANSI")]),
                ]),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.globalIsUserAllowed("Hard_Drive_Tracking_Menu")
          ? _c(
              "li",
              {
                staticClass: "has-submenu",
                class: { open: _vm.groups.hdt && !_vm.collapsed },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "text_format group-row",
                    attrs: {
                      title: _vm.collapsed ? "Hard Drive Tracking" : null,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.toggleGroup("hdt")
                      },
                    },
                  },
                  [
                    _c("span", { staticClass: "group-row-main" }, [
                      _c(
                        "span",
                        { staticClass: "nav-icon" },
                        [_c("fa", { attrs: { icon: ["fas", "hdd"] } })],
                        1
                      ),
                      _vm._v(" "),
                      _c("span", { staticClass: "label" }, [
                        _vm._v("Hard Drive Tracking"),
                      ]),
                    ]),
                    _vm._v(" "),
                    !_vm.collapsed
                      ? _c(
                          "span",
                          { staticClass: "nav-icon submenu-caret" },
                          [
                            _c("fa", {
                              attrs: { icon: ["fas", "angle-right"] },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]
                ),
                _vm._v(" "),
                _c("ul", { staticClass: "submenu" }, [
                  _vm.globalIsUserAllowed("Hard_Drive_Tracking")
                    ? _c(
                        "li",
                        {
                          staticClass: "submenu-item",
                          on: {
                            click: function ($event) {
                              return _vm.loadProjectAction(
                                "Hard Drive Tracking"
                              )
                            },
                          },
                        },
                        [_vm._m(9)]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.globalIsUserAllowed("HDT_Admin_Console")
                    ? _c(
                        "li",
                        {
                          staticClass: "submenu-item",
                          on: {
                            click: function ($event) {
                              return _vm.$emit("initHDTAdminConsole")
                            },
                          },
                        },
                        [_vm._m(10)]
                      )
                    : _vm._e(),
                ]),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.globalIsUserAllowed("Vehicles")
          ? _c(
              "li",
              {
                attrs: { title: _vm.collapsed ? "Vehicle Status" : null },
                on: {
                  click: function ($event) {
                    return _vm.showModal("fleetioVehiclesModal")
                  },
                },
              },
              [
                _c("div", { staticClass: "text_format" }, [
                  _c(
                    "span",
                    { staticClass: "nav-icon" },
                    [_c("fa", { attrs: { icon: ["fas", "truck"] } })],
                    1
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "label" }, [
                    _vm._v("Vehicle Status"),
                  ]),
                ]),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.globalIsUserAllowed("Work_Management_System")
          ? _c(
              "li",
              {
                attrs: {
                  title: _vm.collapsed ? "Work Management System" : null,
                },
                on: {
                  click: function ($event) {
                    return _vm.showModal("WMSModal")
                  },
                },
              },
              [
                _c("div", { staticClass: "text_format" }, [
                  _c(
                    "span",
                    { staticClass: "nav-icon" },
                    [_c("fa", { attrs: { icon: ["fas", "clipboard-check"] } })],
                    1
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "label" }, [
                    _vm._v("Work Management System"),
                  ]),
                ]),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.globalIsUserAllowed("WCL")
          ? _c(
              "li",
              {
                class: { active: _vm.currentPage === "WCL" },
                attrs: { title: _vm.collapsed ? "WCL" : null },
                on: {
                  click: function ($event) {
                    return _vm.handleToolNav("WCL", "WCL")
                  },
                },
              },
              [
                _c("div", { staticClass: "text_format" }, [
                  _c(
                    "span",
                    { staticClass: "nav-icon" },
                    [_c("fa", { attrs: { icon: ["fas", "road"] } })],
                    1
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "label" }, [_vm._v("WCL")]),
                ]),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.globalIsUserAllowed("Data_Tools")
          ? _c(
              "li",
              {
                attrs: { title: _vm.collapsed ? "Data Tools" : null },
                on: {
                  click: function ($event) {
                    return _vm.loadProjectAction("DDT")
                  },
                },
              },
              [
                _c("div", { staticClass: "text_format" }, [
                  _c(
                    "span",
                    { staticClass: "nav-icon" },
                    [_c("fa", { attrs: { icon: ["fas", "database"] } })],
                    1
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "label" }, [_vm._v("Data Tools")]),
                ]),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.globalIsUserAllowed("Sales")
          ? _c(
              "li",
              {
                attrs: { title: _vm.collapsed ? "Sales" : null },
                on: {
                  click: function ($event) {
                    return _vm.loadProjectAction("Sales")
                  },
                },
              },
              [
                _c("div", { staticClass: "text_format" }, [
                  _c(
                    "span",
                    { staticClass: "nav-icon" },
                    [_c("fa", { attrs: { icon: ["fas", "chart-line"] } })],
                    1
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "label" }, [_vm._v("Sales")]),
                ]),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.globalIsUserAllowed("Spatial_Intelligence")
          ? _c(
              "li",
              {
                attrs: { title: _vm.collapsed ? "Spatial Intelligence" : null },
                on: {
                  click: function ($event) {
                    return _vm.loadProjectAction("Spatial_Intelligence")
                  },
                },
              },
              [
                _c("div", { staticClass: "text_format" }, [
                  _c(
                    "span",
                    { staticClass: "nav-icon" },
                    [_c("fa", { attrs: { icon: ["fas", "globe-americas"] } })],
                    1
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "label" }, [
                    _vm._v("Spatial Intelligence"),
                  ]),
                ]),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.globalIsUserAllowed("UAC")
          ? _c(
              "li",
              {
                staticClass: "has-submenu",
                class: { open: _vm.groups.uac && !_vm.collapsed },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "text_format group-row",
                    attrs: { title: _vm.collapsed ? "Admin Features" : null },
                    on: {
                      click: function ($event) {
                        return _vm.toggleGroup("uac")
                      },
                    },
                  },
                  [
                    _c("span", { staticClass: "group-row-main" }, [
                      _c(
                        "span",
                        { staticClass: "nav-icon" },
                        [_c("fa", { attrs: { icon: ["fas", "cog"] } })],
                        1
                      ),
                      _vm._v(" "),
                      _c("span", { staticClass: "label" }, [
                        _vm._v("Admin Features"),
                      ]),
                    ]),
                    _vm._v(" "),
                    !_vm.collapsed
                      ? _c(
                          "span",
                          { staticClass: "nav-icon submenu-caret" },
                          [
                            _c("fa", {
                              attrs: { icon: ["fas", "angle-right"] },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]
                ),
                _vm._v(" "),
                _c("ul", { staticClass: "submenu" }, [
                  _vm.globalIsUserAllowed("UAC")
                    ? _c(
                        "li",
                        {
                          staticClass: "submenu-item",
                          on: {
                            click: function ($event) {
                              return _vm.$bvModal.show("UACModal")
                            },
                          },
                        },
                        [_vm._m(11)]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.globalIsUserAllowed("Access_Control")
                    ? _c(
                        "li",
                        {
                          staticClass: "submenu-item",
                          on: {
                            click: function ($event) {
                              return _vm.$bvModal.show("AccessControlModal")
                            },
                          },
                        },
                        [_vm._m(12)]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.globalIsUserAllowed("Release_Version")
                    ? _c(
                        "li",
                        {
                          staticClass: "submenu-item",
                          on: {
                            click: function ($event) {
                              return _vm.$bvModal.show("versionReleaseModal")
                            },
                          },
                        },
                        [_vm._m(13)]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.globalIsUserAllowed("MMP_Deliveries")
                    ? _c(
                        "li",
                        {
                          staticClass: "submenu-item",
                          on: {
                            click: function ($event) {
                              return _vm.$bvModal.show("deliveriesModal")
                            },
                          },
                        },
                        [_vm._m(14)]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.globalIsUserAllowed("Automate_Scripts")
                    ? _c(
                        "li",
                        {
                          staticClass: "submenu-item",
                          on: {
                            click: function ($event) {
                              return _vm.$bvModal.show("DPRScripts")
                            },
                          },
                        },
                        [_vm._m(15)]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.globalIsUserAllowed("Automate_Scripts")
                    ? _c(
                        "li",
                        {
                          staticClass: "submenu-item",
                          on: {
                            click: function ($event) {
                              return _vm.$bvModal.show("ScriptSettings")
                            },
                          },
                        },
                        [_vm._m(16)]
                      )
                    : _vm._e(),
                ]),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.mapsMode
          ? _c(
              "li",
              {
                staticClass: "logout",
                attrs: { title: _vm.collapsed ? "Sign Out" : null },
                on: { click: _vm.signOut },
              },
              [
                _c("div", { staticClass: "text_format" }, [
                  _c(
                    "span",
                    { staticClass: "nav-icon" },
                    [_c("fa", { attrs: { icon: ["fas", "sign-out-alt"] } })],
                    1
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "label" }, [_vm._v("Sign Out")]),
                ]),
              ]
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("ul", { staticClass: "nav-collapse-list" }, [
        _c(
          "li",
          {
            staticClass: "nav-collapse-toggle",
            attrs: {
              title: _vm.collapsed ? "Expand sidebar" : "Collapse sidebar",
            },
            on: { click: _vm.toggleCollapse },
          },
          [
            _c("div", { staticClass: "nav-toggle-inner" }, [
              _c(
                "span",
                {
                  staticClass: "nav-toggle-btn",
                  class: { collapsed: _vm.collapsed },
                },
                [
                  _c("fa", {
                    staticClass: "nav-toggle-icon",
                    attrs: { icon: ["fas", "angle-left"] },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("span", { staticClass: "nav-toggle-text label" }, [
                _vm._v("Collapse"),
              ]),
            ]),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "a",
      { attrs: { href: "https://dmp-maps.com/", target: "_blank" } },
      [
        _c("img", {
          staticClass: "logo",
          attrs: { src: require("../../assets/dmpLogo.png"), alt: "Banner" },
        }),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "text_format" }, [
      _c("span", { staticClass: "label" }, [
        _vm._v("Daily Productivity Report"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "text_format" }, [
      _c("span", { staticClass: "label" }, [_vm._v("Entry Manager")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "text_format" }, [
      _c("span", { staticClass: "label" }, [_vm._v("Reports")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "text_format" }, [
      _c("span", { staticClass: "label" }, [_vm._v("Admin Console")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "text_format" }, [
      _c("span", { staticClass: "label" }, [_vm._v("GTP Tracking")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "text_format" }, [
      _c("span", { staticClass: "label" }, [_vm._v("GTP Report")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "text_format" }, [
      _c("span", { staticClass: "label" }, [_vm._v("Field Images")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "text_format" }, [
      _c("span", { staticClass: "label" }, [_vm._v("EOD Field Trail Review")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "text_format" }, [
      _c("span", { staticClass: "label" }, [_vm._v("Hard Drive Tracking")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "text_format" }, [
      _c("span", { staticClass: "label" }, [_vm._v("Admin Console")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "text_format" }, [
      _c("span", { staticClass: "label" }, [_vm._v("User Account Control")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "text_format" }, [
      _c("span", { staticClass: "label" }, [_vm._v("Access Control")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "text_format" }, [
      _c("span", { staticClass: "label" }, [_vm._v("Release Version")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "text_format" }, [
      _c("span", { staticClass: "label" }, [_vm._v("MMP Deliveries")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "text_format" }, [
      _c("span", { staticClass: "label" }, [_vm._v("DPR Automation")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "text_format" }, [
      _c("span", { staticClass: "label" }, [_vm._v("DRT / ANSI Automation")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }